import { ActionTypes } from '../types/action-types';

export const expandConfigView = (isExpanded: boolean) => ({
    type: ActionTypes.UI_INTEGRATE_UPDATED,
    configuredExpanded: isExpanded,
});
export const expandBYODView = (isExpanded: boolean) => ({
    type: ActionTypes.UI_BYOD_UPDATED,
    byodExpanded: isExpanded
});
export const expandWebhookView = (isExpanded: boolean) => ({
    type: ActionTypes.UI_WEBHOOK_UPDATED,
    webhookExpanded: isExpanded
});



// WEBPACK FOOTER //
// ./src/sub-projects/salesforce/actions/app.ts